export default "__VITE_ASSET__BVc7hedr__"